<template>
 <div class="content">
  <div class="header">
    <h1>{{ pageTitle }}</h1>
  </div>
  <div class="content-body table-wrapper">
    <div class="block"><BomUploadMap></BomUploadMap></div>
  </div>
 </div>
</template>
<script>
import BomUploadMap from './components/bom-upload-map'
export default {
  name: 'BomImportMap',
  components: {
    BomUploadMap
  },
  computed: {
    pageTitle () {
      document.title = this.$t('menu.bom.upload_map')
      return document.title
    }
  }
}
</script>
